import { FAIcon } from "../core/components/faIcon";
import { ComponentHelper } from "../core/util/componentHelper";
import { Helper } from "../core/util/helper";
import { HTTPService } from "../core/util/httpManager";
import { TextBox } from "../core/components/textBox"
import React from "react";
export default class CheckIfReachableTextBox extends React.Component<CheckIfReachableTextBoxProps, CheckIfReachableTextBoxState>{
    private factory = ComponentHelper.createFactory();
    constructor(props) {
        super(props);
        this.state = {
            hash: -1,
            infoState: "none"
        }
    }

    private update = (baseUrl) => {
        const hash = Helper.getHashCode(baseUrl);
        if (hash != this.state.hash) {
            this.setState({ hash: hash, infoState: Helper.isNullOrEmpty(baseUrl) ? "none" : "checking" }, () => {
                if (!Helper.isNullOrEmpty(baseUrl))
                    this.checkUrl();
            });
        }
    };

    private checkUrl = async () => {
        const result = await HTTPService.noBusyIndicator().get<boolean>(`InnoBot/IsReachable?baseUrl=${encodeURI(this.props.value)}`);
        this.setState({ infoState: result ? "isReachable" : "isNonReachable" });
    };

    private renderIcon = () => {
        switch (this.state.infoState) {
            case "checking":
                return (
                    <>
                        <FAIcon name="spinner" prefix="fas" spins={true} attributes={["2x"]} style={{ width: "fit-content" }} />
                    </>
                );
            case "isReachable":
                return (
                    <>
                        <FAIcon name="check" prefix="fas" attributes={["2x"]} style={{ color: "#2e7d32" }} />
                    </>
                );
            case "isNonReachable":
                return (
                    <>
                        <FAIcon name="times" prefix="fas" attributes={["2x"]} style={{ color: "#e53935" }} />
                    </>
                );
            case "none":
            default:
                return null;
        }
    }

    private renderTextBox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.props.value;
        props.field = this.props.field;
        props.onChange = this.props.onChange;
        return (
            <>
                <TextBox {...props} />
            </>
        );
    };

    componentDidUpdate() {
        this.update(this.props.value);
    }

    componentDidMount() {
        this.update(this.props.value);
    }

    render() {
        return (
            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                <div style={{ width: "min-content", marginLeft: "3px" }}>
                    {this.renderIcon()}
                </div>
                {this.renderTextBox()}
            </div>
        );
    }
}


interface CheckIfReachableTextBoxProps {
    value: string;
    field: any;
    onChange: any
}

interface CheckIfReachableTextBoxState {
    hash: number;
    infoState: "none" | "isNonReachable" | "checking" | "isReachable"
}